/*
 * Copyright (c) 2022 Robert J Whelton. All rights reserved.
 */

import * as React from "react"
import SwipeableDrawer from "@mui/material/SwipeableDrawer"
import Toolbar from "@mui/material/Toolbar"
import {useTheme} from "@mui/material/styles"
import useMediaQuery from "@mui/material/useMediaQuery"

import {ToggleFunctionType} from "../layouts/Layout"


interface FormDrawerProps {
  open: boolean
  toggleDrawer: ToggleFunctionType
  anchor: "top" | "bottom" | "left" | "right"
  children?: any
}

export const enterSpeedFactor = 600
export const exitSpeedFactor = 400
export const mobileDrawerWidthFactor = 95
export const standardWidthFactor = 20
export const standardMinWidth = 250

const BaseDrawer: React.FC<FormDrawerProps> = ({
                                                 open,
                                                 toggleDrawer,
                                                 anchor,
                                                 children
                                               }) => {
  const theme = useTheme()
  const isMobile = !useMediaQuery(theme.breakpoints.up("sm"))
  const isSideDrawer = (anchor === "left" || anchor === "right")
  const zIndexIncrease = (isSideDrawer ? 3 : 10)

  return (
    <SwipeableDrawer
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + zIndexIncrease,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          zIndex: (theme) => theme.zIndex.drawer + zIndexIncrease,
          height: "100vh",
          width: (isMobile ? `${mobileDrawerWidthFactor}vw` : `${standardWidthFactor}%`),
          boxSizing: "border-box",
          minWidth: standardMinWidth
        },
      }}
      variant={isMobile || !isSideDrawer ? "temporary" : "persistent"}
      anchor={anchor}
      open={open}
      onClose={toggleDrawer(open)}
      onOpen={toggleDrawer(open)}
      transitionDuration={{
        enter: theme.transitions.getAutoHeightDuration(enterSpeedFactor),
        exit: theme.transitions.getAutoHeightDuration(exitSpeedFactor)
      }}
    >
      {isSideDrawer ? <Toolbar  variant="dense"/> : <></>}
      {children}
    </SwipeableDrawer>
  )
}

export default BaseDrawer
